<template>
  <div class="markers-table">
    <div class="row header hidden-xs hidden-sm">
      <div class="col-md-4"></div>
      <div class="col-md-2">{{ $t('marker.targeted_groups') }}</div>
      <div class="col-md-2">{{ $t('marker.start_date') }}</div>
      <div class="col-md-2">{{ $t('marker.end_date') }}</div>
      <div class="col-md-2">{{ $t('marker.records_count') }}</div>
    </div>
    <marker-row class="row" :key="marker.id" :marker="marker" @trash="deleteMarker" v-for="marker in markers">
    </marker-row>
  </div>
</template>

<script>
// Render a list of markers as a table

import ConfirmModal from '../generic/ConfirmModal.vue'
import MarkerRow from './MarkerRow.vue'

export default {
  props: ['markers'],
  components: {
    ConfirmModal,
    MarkerRow
  },
  methods: {
    deleteMarker (marker) {
      this.$emit('trash', marker)
    }
  }
}
</script>
